import * as React from "react"
import {useEffect, useState} from "react";
import {navigate} from "gatsby";
import CookiesMessage from "../CookiesMessage/CookiesMessage";
import TermsAccordion from "../TermsAccordion/TermsAccordion";
import LanguageSwitch from "../LanguageSwitch/LanguageSwitch";
import T from "../T/T";
import "./styles.scss";
import {hasQueryParams, hasInfoQueryParams, getQueryParams} from "../../lib/Misc";
import {useImageLoaded} from "../../lib/ImageOnLoad";
import {LocaleLink, CurrentLocale} from "../../lib/IntlTools";
import {useIntl} from "gatsby-plugin-intl";
import PagePreload from "../PagePreload/PagePreload";

export default function Layout({
                                   isProductPassportView,
                                   children,
                                   hideTermsAccordion,
                                   hideCookies,
                                   hideLanguages,
                                   noHeaderSpace,
                                   extraMainClass,
                                   selectedDisplay,
                                   showLogoLink,
                                   hideHeader
                               }) {
    // const [selectedDisplay, setSelectedDisplay] = useState(null);
    const [usedPreload, setUsedPreload] = useState(false);
    const [showReward, setShowReward] = useState(false);
    const [windowClass, setWindowClass] = useState('');
    const [windowPath, setWindowPath] = useState('');
    const [userAge, setUserAge] = useState(1)
    const [userAgeConfirmed, setUserAgeConfirmed] = useState(0)
    // const [ref, loaded, onLoad] = useImageLoaded();
    const intl = useIntl();
    const translatedExtraFooterText = intl.formatMessage({id: 'footer-extra-text'});

    const currentLang = CurrentLocale();

    useEffect(() => {
        setUserAge(parseInt(localStorage.getItem("userAge") || 1));
        // setUserAgeConfirmed(parseInt(localStorage.getItem("userAgeConfirmed") || 0));
    })

    // Hide if there are no query params
    useEffect(() => {
        setUsedPreload(parseInt(localStorage.getItem("preloaded") || 0));
        // setSelectedDisplay(localStorage.getItem("selecteddisplay") || null);

        if (typeof window !== "undefined") {
            setWindowPath(window.location.pathname);
            setWindowClass(window.location.pathname.split('/')[3] || window.location.pathname.split('/')[2] || window.location.pathname.split('/')[1]);

            if (window.location.pathname.split('/')[1] !== currentLang) {
                return (hasQueryParams() || hasInfoQueryParams())
                    ? navigate(LocaleLink(window.location.pathname + window.location.search))
                    : navigate(LocaleLink(window.location.pathname))
            }

        }

        if (hasQueryParams) {

        }

        setShowReward(hasQueryParams());
    }, [currentLang]);

    hideLanguages = true; // @todo remove it (temporary language switch disable)

    let headerClasses = "uk-navbar uk-navbar-container uk-navbar-transparent design-header";

    if (noHeaderSpace) {
        headerClasses += " no-space";
    }

    const ageConfirmation = () => {
        setUserAgeConfirmed(1);
    }

    return (
        <div
            className={`main 
            ${windowClass !== '404' ? windowClass : 'problem'} 
            ${selectedDisplay ? selectedDisplay + '-display' : 'unselected-display'} 
            ${showReward ? 'claim' : ''}
             ${windowPath !== '/skl/' ? 'footer-fill' : ''} 
             ${extraMainClass}`}
            id="main">

            {!hideHeader&&(  <nav className={headerClasses}>
                <div className="navi-logo-holder">
                    {!showLogoLink ? (
                        <img src="/static/images/logo.svg" alt=""/>
                    ) : (
                        <a href="/cpa/">
                            <img src="/static/images/logo.svg" alt=""/>
                        </a>
                    )}
                </div>

                {!hideLanguages ? (
                    <LanguageSwitch/>
                ) : null}
            </nav>)}

            <div className="content" id="content">
                {children}
            </div>

            {(selectedDisplay !== null) ? (
                <div className={`footer-container ${showReward ? 'claim' : ''}`}>
                    {!hideTermsAccordion && !isProductPassportView  ? (
                        <TermsAccordion/>
                    ) : null}

                    {!isProductPassportView && (<div className="copy-right">
                        <img src="/static/images/logo.svg" alt=""/>

                        <h5 className="uk-text-center"
                            dangerouslySetInnerHTML={{__html: translatedExtraFooterText}}>
                        </h5>
                    </div>)}


                    <div className="powered-by">
                        <h5 className="uk-text-center">
                            <T>
                                powered-by
                            </T>

                            <img src="/static/images/fabacus-logo-white.png" alt=""/>
                        </h5>
                    </div>

                </div>
            ) : null}
            {(!hideCookies && selectedDisplay !== 'passport') && !isProductPassportView ? (
                <CookiesMessage/>
            ) : null}
        </div>
    )
}
